import { Modal } from 'bootstrap';
function registerAlertItems(): void {
  const currentDate = new Date();

  const alerts = document.querySelectorAll<HTMLElement>(`.alert-items > .alert`);
  const globalPopupModals = document.querySelectorAll<HTMLElement>(`.globalPopupModal`);

  alerts.forEach(alert => {
    const alertDismissDays = parseInt(alert.dataset.alertDismissDurationDays || '0', 10);
    const alertId = alert.dataset.alertId;
    const alertDismissButtons = alert.querySelectorAll<HTMLElement>(`.alert-dismiss-button`);

    alertDismissButtons.forEach(dismissButton => {
      dismissButton.addEventListener('click', event => {
        setSpacerHeights();
        if (alertDismissDays === 0) {
          // Use session storage for alerts set to dismiss after 0 days
          sessionStorage.setItem(`alert-dismiss-${alertId}`, 'session');

          // set cookie, as session storage is not shared between tabs
          document.cookie = `alert-dismiss-${alertId}=session; expires=0; path=/`;
        } else {
          // Use local storage for alerts set to dismiss otherwise, containing date they will no longer be dismissed
          const dismissUntilDate = new Date(currentDate);
          dismissUntilDate.setDate(currentDate.getDate() + alertDismissDays);
          localStorage.setItem(`alert-dismiss-${alertId}`, dismissUntilDate.toISOString());
        }
      });
    });

    // If alert is not dismissible or it is not dismissed in either session nor local storage, then show it
    const dismissible = alert.dataset.alertDismissible === 'true';
    const sessionStorageDismissValue = sessionStorage.getItem(`alert-dismiss-${alertId}`);
    const cookieDismissValue = document.cookie.includes(`alert-dismiss-${alertId}=`);
    const localStorageDismissUntilDate = new Date(localStorage.getItem(`alert-dismiss-${alertId}`) || null);

    if (!dismissible || (!cookieDismissValue && !sessionStorageDismissValue && localStorageDismissUntilDate < currentDate)) {
      alert.classList.add('show');
    }
  });

  globalPopupModals.forEach(globalPopupModal => {
    const alertDismissDays = parseInt(globalPopupModal.dataset.alertDismissDurationDays || '0', 10);
    const alertId = globalPopupModal.dataset.alertId;
    const alertDismissButtons = globalPopupModal.querySelectorAll<HTMLElement>(`.alert-dismiss-button`);

    alertDismissButtons.forEach(dismissButton => {
      dismissButton.addEventListener('click', event => {
        setSpacerHeights();
        if (alertDismissDays === 0) {
          // Use session storage for alerts set to dismiss after 0 days
          sessionStorage.setItem(`alert-dismiss-${alertId}`, 'session');

          // set cookie, as session storage is not shared between tabs
          document.cookie = `alert-dismiss-${alertId}=session; expires=0; path=/`;
        } else {
          // Use local storage for alerts set to dismiss otherwise, containing date they will no longer be dismissed
          const dismissUntilDate = new Date(currentDate);
          dismissUntilDate.setDate(currentDate.getDate() + alertDismissDays);
          localStorage.setItem(`alert-dismiss-${alertId}`, dismissUntilDate.toISOString());
        }
      });
    });

    // If alert is not dismissible or it is not dismissed in either session nor local storage, then show it
    const dismissible = globalPopupModal.dataset.alertDismissible === 'true';
    const sessionStorageDismissValue = sessionStorage.getItem(`alert-dismiss-${alertId}`);
    const cookieDismissValue = document.cookie.includes(`alert-dismiss-${alertId}=`);
    const localStorageDismissUntilDate = new Date(localStorage.getItem(`alert-dismiss-${alertId}`) || null);

    if (!dismissible || (!cookieDismissValue && !sessionStorageDismissValue && localStorageDismissUntilDate < currentDate)) {
      const globalPopupTrigger = document.querySelectorAll<HTMLElement>('button[data-bs-target="#globalPopupModal"]');
      if (globalPopupTrigger) {
        const globalPopupModalModal = new Modal(globalPopupModal);
        globalPopupModalModal.show();
      }
    }
  });


  setSpacerHeights();
}

// Set the height of alert spacers to the height of the alert to prevent content from being obstructed
function setSpacerHeights(): void {
  const alertSpacers = document.querySelectorAll<HTMLElement>(`.alert-spacer`);
  alertSpacers.forEach(x => {
    const nextElement = x.nextElementSibling as HTMLElement | null;
    if (nextElement) {
      x.style.height = nextElement.offsetHeight + 'px';
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  registerAlertItems();
});
